/**
 * Toast type constants.
 *
 * Import instead of writing the string literal:
 *
 *     import { showToast, TOAST_TYPE } from "@/components/Common/Toast";
 *     showToast("Saved", { type: TOAST_TYPE.SUCCESS });
 *
 * ⚠️ Same reasoning as BUTTON_VARIANT: a mistyped type falls through to the
 * default styling with no error, so a frozen object turns the typo into an
 * obvious `undefined` at the call site.
 */
export const TOAST_TYPE = Object.freeze({
  SUCCESS: "success",
  ERROR: "error",
  INFO: "info",
  WARNING: "warning",
});

export const TOAST_TYPES = Object.values(TOAST_TYPE);

/**
 * The app-wide container id for form submit feedback.
 *
 * `components/Layout.jsx` mounts exactly one `<Toaster>` with this id, and the
 * contact/sample/quote forms pass it to every `showToast` call. Use this rather
 * than a per-component id: those forms render in modals and in several instances
 * per page, so a container owned by a form gets duplicated — and duplicate
 * containers sharing one id render each toast once per container.
 *
 * ⚠️ Never mount a second container with this id.
 */
export const FORM_TOAST_CONTAINER_ID = "elchemy-form-toast";

/** Default auto-dismiss, ms. Errors get longer — they need reading. */
export const TOAST_DURATION = Object.freeze({
  SHORT: 3000,
  DEFAULT: 4000,
  LONG: 6000,
});
